export default __webpack_public_path__ + "static/media/responsive-demo-airbnb-clone.c61a9bab.png";